import { render, staticRenderFns } from "./supportDialog.vue?vue&type=template&id=0918ec83"
import script from "./supportDialog.vue?vue&type=script&lang=js"
export * from "./supportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports